export default __webpack_public_path__ + "static/media/BICO.5a163b58.png";